import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { AppConstant } from 'src/app/constants/app.constant';
import { AuthService } from 'src/app/core/services/auth.service';
import { CreditLineFNB } from 'src/app/models/account/credit-line-fnb.model';
import { CommonService } from 'src/app/services/common.service';
declare var gtag: Function;
@Component({
  selector: 'app-popup-fnb',
  templateUrl: './popup-fnb.component.html'
})
export class PopupFnbComponent implements OnInit {

  registroConfiguracion: any;
  line01: string;
  line02: string;
  line03: string;
  line04: string;
  line05: string;
  creditLineFNB: CreditLineFNB = new CreditLineFNB();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private dialogRef: MatDialogRef<PopupFnbComponent>,
              private router: Router,
              private commonService: CommonService,
              private authService: AuthService) { }

  ngOnInit() {
    this.creditLineFNB = this.authService.getCreditLineFNB();
    this.registroConfiguracion = this.data.registro;
    this.assignLineCreditData();
    this.generateContentLines();
  }

  assignLineCreditData(): void {
    let content = this.registroConfiguracion.contenido as string;
    content = content.replace(AppConstant.userMask, this.creditLineFNB.firstName);
    content = content.replace(AppConstant.amountMask, this.creditLineFNB.amountFormat);
    this.registroConfiguracion.contenido = content;
  }

  generateContentLines(): void {
    const paragraphList = this.registroConfiguracion.contenido.split(AppConstant.paragraphSeparator);
    if (paragraphList.length > 0) {
      this.line01 = (paragraphList.length > 1) ? this.generateLine(paragraphList[0]) : null;
      this.line02 = (paragraphList.length > 2) ? this.generateLine(paragraphList[1]) : null;
      this.line03 = (paragraphList.length > 3) ? this.generateLine(paragraphList[2]) : null;
      this.line04 = (paragraphList.length > 4) ? this.generateLine(paragraphList[3]) : null;
      this.line05 = (paragraphList.length > 5) ? this.generateLine(paragraphList[4]) : null;
    }
  }

  generateLine(linePrevious: string): string {
    return `${linePrevious}${AppConstant.paragraphSeparator}`;
  }

  goToVirtualStore(): void {
    gtag('event', 'select_content');
    this.commonService.announcePopupClosed(true);
    this.dialogRef.close(false);
    this.router.navigate(['/ofivirtual/tienda']);
  }
}
